/**
 * DFT-0077 (AD-5): shared helper extracting the backend's own explanation from a failed API call,
 * falling back to a generic i18n string when none is present. Modelled on the one existing Bay
 * Hire instance of this pattern (`ReasonDialog.tsx`'s `handleSubmitForm` catch block, added by
 * DFT-0066 AD-6) rather than adding a 12th hand-rolled variant - the repo has ~54 files with
 * ~90+ occurrences of this same shape platform-wide (e.g.
 * `features/licensing/license-details/LicenseDetails.tsx`'s `getErrorDetail`), and Bay Hire was
 * the outlier that mostly didn't do it.
 *
 * Deliberately reads `response.data.detail` ONLY, matching ReasonDialog's narrower check rather
 * than the broader multi-fallback shape some other features use (which also reads
 * `response.data.message`/`data.detail`/`error.message`) - confirmed against both Bay Hire
 * backends' `GlobalExceptionHandler`s that every relevant exception serializes its message into
 * exactly this field (`bay-hire-service`'s custom `ProblemDetails.detail(ex.getMessage())`,
 * `bff-bay-hire-service`'s `ProblemDetails.detail(ex.getReason())` for `ResponseStatusException`).
 *
 * @param error the caught error, typically an Axios error shape (untyped - error shapes vary).
 * @param fallback the i18n-resolved generic message to use when no backend detail is present
 *                 (e.g. a network-level failure with no response body at all).
 */
export function getApiErrorDetail(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === "string" && detail.trim().length > 0 ? detail : fallback;
}
